import { Modal } from 'antd';
import { observer } from 'mobx-react-lite';
import SVGPureIcon from '@ui/svg-icon';
import MultipleTaskSearchItem from './search-item';
import MultipleTaskSearchStore from './store';

const MultipleTaskSearchItemModal = ({ data }) => {
  const { currentFullScreenData } = MultipleTaskSearchStore;

  // 判断当前是否 是全屏节点
  const iscurrent = data.find(
    item => item.buTaskId === currentFullScreenData?.buTaskId
  );

  if (!currentFullScreenData || !iscurrent) {
    return null;
  }

  return (
    <Modal
      open={true}
      width={720}
      centered
      className='multiple-task-search-modal'
      onCancel={() => {
        MultipleTaskSearchStore.setFullScreenData(null);
      }}
      footer={null}
      closable={false} // 隐藏关闭按钮
    >
      <SVGPureIcon
        name="icon_fullscreen_fold"
        className="absolute top-20px right-20px size-24px text-primary-opacity text-opacity-50 hover:text-opacity-100 cursor-pointer"
        onClick={() => {
          MultipleTaskSearchStore.setFullScreenData(null);
        }}
      />
      <MultipleTaskSearchItem
        item={currentFullScreenData}
        isFullScreenModal={true}
      />
    </Modal>
  );
};

export default observer(MultipleTaskSearchItemModal);
